import { createContext } from "react";

export const surveyContext = createContext<SurveyContextProps | null>(null);
export type SurveyContextProps = {
    id: number;
};
